import { useAuth } from "../../context/AuthContext";

const Carepreneur = () => {
    const { userInfo } = useAuth()
    // console.log("userInfo=>", JSON.stringify(userInfo, null, 2));

    const parsed = JSON.parse(JSON.stringify(userInfo));
    const newQuery: Record<string, string> = parsed
        ? {
            agency_id: parsed?.agencies?.id?.toString(),
            agency_name: parsed?.agencies?.company_name?.toString(),
            email_id: parsed?.email_id?.toString(),
            mobile_number: parsed?.contact_no?.toString(),
            uuid: parsed?.uuid?.toString(),
            first_name: parsed?.first_name?.toString(),
            last_name: parsed?.last_name?.toString(),
            middle_name: parsed?.middle_name?.toString(),
            access_type: parsed?.access_type?.toString(),
            sso_id: parsed?.uuid?.toString(),
            role: parsed?.employee_roles?.[0]?.role_name?.toString(),
        }
        : {};

    return (
        <div>
            {/* <iframe
                // src={`http://localhost:5173/?${new URLSearchParams(newQuery).toString()}`}
                src={`https://white-ocean-011543b0f.1.azurestaticapps.net/?${new URLSearchParams(newQuery).toString()}`}
                width="100%"
                height="100%"
                style={{ border: 'none', position: 'fixed', top: 0, left: 0, bottom: 0, right: 0 }}
                title="Carepreneur Iframe"
            /> */}

            <iframe
                src={`https://white-ocean-011543b0f.1.azurestaticapps.net/?${new URLSearchParams(newQuery).toString()}`}
                width="100%"
                height="100%"
                style={{ border: 'none', position: 'fixed', top: 0, left: 0, bottom: 0, right: 0 }}
                title="Carepreneur Iframe"
                allow="microphone; autoplay"
                allowFullScreen
            />
        </div>
    )
}

export default Carepreneur
